import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class KnowYourColleagueService {

  baseUrl = environment.baseUrl
  constructor(private httpClient: HttpClient) { }

  findColleagues(purchaserCode: any, materialGroup: any, username: any, role: any, brand: any, pageNo: any, pageSize: any, materialGroupDescription: any) {
    return this.httpClient
      .get(this.baseUrl + `/get_material_purchaser_data?brand=${brand}&role=${role}&name=${username}&purchaserCode=${purchaserCode}&materialGroup=${materialGroup}&pageNo=${pageNo}&pageSize=${pageSize}&materialGroupDescription=${materialGroupDescription}`)
  }

  getUserFunctionDropdown(){
    return this.httpClient.get(this.baseUrl+`/get_user_function_dropdown`);
  }

//purchaserCode, materialGroup, username, role, brand
}
